import i18n from "@/modules/core/localization/i18n";
import store from "@/store/store";
import Vue from "vue";

//ay bazlı çalışır
Vue.filter("period", function(months = 12) {
  const years = Math.floor(months / 12);
  const modMonths = months % 12;
  if (years == 0 && modMonths == 0) {
    return `${years} ` + i18n.t("common.year");
  }

  let period = "";

  if (years > 0) {
    period += `${years} ` + i18n.t("common.year") + " ";
  }

  if (modMonths > 0) {
    period += `${modMonths} ` + i18n.t("common.month") + " ";
  }

  return period.trim();
});

Vue.filter("duration", function formatDuration(durationMs) {
  if (durationMs == null || durationMs <= 0) return "-";

  const language = store.getters["user/account"]?.language ?? "tr";
  const locale = language === "tr" ? "tr-TR" : "en-US";

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;

  const parts = [];

  // 1. Günleri göster
  const days = Math.floor(durationMs / day);
  if (days > 0) {
    parts.push(`${days} ${i18n.t("common.day")}`);
    durationMs %= day;
  }

  // 2. Saatleri göster
  const hours = Math.floor(durationMs / hour);
  if (hours > 0) {
    parts.push(`${hours} ${i18n.t("common.hour")}`);
    durationMs %= hour;
  }

  // 3. Dakikaları göster
  const minutes = Math.floor(durationMs / minute);
  if (minutes > 0) {
    parts.push(`${minutes} ${i18n.t("common.minute")}`);
  }

  // 4. Hiçbir parça çıkmadıysa (çok küçük değerler için)
  if (parts.length === 0) {
    parts.push(`0 ${i18n.t("common.minute")}`);
  }

  return parts.join(" ");
});

Vue.filter("addMonth", function addMonth(date, value = 1) {
  value = Number(value);
  date = date || new Date();
  const mutation = new Date(date.getTime());
  mutation.setMonth(mutation.getMonth() + value);
  return mutation;
});

Vue.filter("translate", (value) => {
  if (typeof value == "string") {
    return value;
  }
  if (value) {
    return value[store.getters["user/account"].language];
  }
  return value;
});

Vue.filter("regulation", (value) => {
  if (typeof value == "string") {
    return value;
  }
  const product = store.getters["product/currentProduct"];
  if (product == "FWSED") {
    return value.fwsedRegulation;
  }
});

// Helper functions for product-specific firm status
export function getStatusFieldByProduct(product) {
  const productUpper = (product || "FWSED").toUpperCase();
  switch (productUpper) {
    case "FWSED":
      return "fwsedStatus";
    default:
      return "fwsedStatus"; // Default to FWSED
  }
}

export function getFirmStatus(firm, product) {
  if (!firm) return undefined;
  const field = getStatusFieldByProduct(product);
  return firm[field];
}

Vue.filter("web", (value) => {
  if (typeof value === "string") {
    if (!value.startsWith("http")) {
      return "http://" + value;
    }
  }
  return value;
});

Vue.filter("date", (value, withTime = false) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return date.toLocaleDateString("tr") + (withTime ? " " + date.toLocaleTimeString("tr") : "");
});

Vue.filter("formatByte", function(value) {
  if (value >= 1024 * 1024 * 1024) {
    return (value / (1024 * 1024 * 1024)).toFixed(1) + " GB";
  } else if (value >= 1024 * 1024) {
    return (value / (1024 * 1024)).toFixed(1) + " MB";
  } else if (value >= 1024) {
    return (value / 1024).toFixed(0) + " KB";
  } else {
    return 0 + " KB";
  }
});

Vue.filter("summary", (value, limit = 30) => {
  if (!value) {
    return value;
  }

  return value.replace(/<[^>]*>?/gm, "").substr(0, limit) + (value.length > limit ? "..." : "");
});

Vue.filter("number", (value) => {
  if (!value) {
    return value;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
